import { IMapper } from "./interfaces";

export class Mapper implements IMapper {
  readonly mappings = {};

  forMember(property, data): IMapper {
    this.mappings[property] = value => {
      return data(value);
    };

    return this;
  }
}
